<template lang="pug">
.post-form__section-wrapper
  .post-form__preview-toggle-btn.html-toggle(
    @click="togglePreview"
    :title="previewToggleButtonTooltip"
  ) {{ previewToggleButtonText }}

  post-form-section-default(
    v-if="!preview"
    ref="field"
    :section="section"
    :section-index="sectionIndex"
    v-on="inputListeners"
  )
  .fieldset(
    v-else
  )
    .fieldset__input.--textarea(
      ref="preview"
      tabindex="0"
      v-html="sectionContent"
      @click="focus"
      @focus="focus"
    )
</template>

<script>
import PostFormSectionDefault from '@/components/post/default-editor/post-form__section--default'

export default {
  name: 'post-form__section--html',
  components: {
    PostFormSectionDefault,
  },
  props: {
    section: {
      type: Object,
      required: true,
    },
    sectionIndex: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      preview: true,
    }
  },
  computed: {
    previewToggleButtonTooltip() {
      return this.preview ? 'Edit' : 'Preview'
    },
    previewToggleButtonText() {
      return this.preview ? '</>' : '<o>'
    },
    sectionContent() {
      return this.section.content
    },
    inputListeners() {
      const vm = this
      return Object.assign({}, this.$listeners, {
        async blur(e) {
          vm.preview = true
          vm.$emit('blur', e)
        },
        keyup(e) {
          if (e.code === 'Escape') vm.preview = true
          vm.$emit('keyup', e)
        },
      })
    }
  },
  methods: {
    // TODO: properly expose these methods upward
    resize() {
      !this.preview && this.$refs.field.resize()
    },
    async focus() {
      if (this.preview) {
        this.preview = false
        await this.$nextTick()
      }
      this.$refs.field.focus()
    },
    async error(msg) {
      if (this.preview) {
        this.preview = false
        await this.$nextTick()
      }
      this.$refs.field.error(msg)
    },
    togglePreview() {
      this.preview = !this.preview
    },
  },
}
</script>

<style lang="sass">
.post-form__section 
  --input-fontsize: var(--post-content-font-size)
  --input-lineheight: var(--post-content-line-height)
  
  .fieldset.--large
    --input-fontsize: var(--post-content-font-size)
    --input-lineheight: var(--post-content-line-height)

  .fieldset__input
    border-bottom: none
    background-position: center left
    background-size: var(--underline-effect-line-height) 0%
    transition: background-size 0.3s, background-image 0.3s, border-color 0.3s, height 0.3s

    &:hover,
    &:active,
    &:focus
      border-bottom: none
      background-size: var(--underline-effect-line-height) calc(100% - var(--input-padding-v) * 2)

.post-form__section-wrapper
  position: relative
  
.post-form__preview-toggle-btn
  cursor: pointer
  position: absolute
  z-index: 50
  bottom: .5rem
  left: calc(100% - 1.5rem)

.html-toggle
  font-size: .8rem
  padding: .2rem .3rem
  background-color: var(--base-color)
  color: white
  border-radius: .2rem
</style>

